import store from '@/store';
import {
  ADD_MESSAGE_STATUS,
  ADD_CURRENT_PROTOCOL,
  SET_JOB_CHANNEL,
} from '@/store/mutation-types.js';
export default class QualifiedAttendanceEvent {
  constructor(body) {
    let channelName = '';

    switch (body.channel.toLowerCase()) {
      case 'whatsapp':
        channelName = 'WhatsApp';
        break;
      case 'voice':
        channelName = 'Voz';
        break;
      case 'chat':
        channelName = 'Chat';
        break;
      default:
        channelName = '';
    }

    store.dispatch('jobs/removeJob', body.protocol);
    store.dispatch('showSnackbar', {
      text: 'qualifiedAttendanceEndJobMessage',
      type: 'success',
      replaces: { channel: channelName, protocol: body.protocol },
    });
    store.commit(`voice/${ADD_MESSAGE_STATUS}`, '');
    store.commit(`voice/${ADD_CURRENT_PROTOCOL}`, '');
  }
}
